import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm, reset } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { CommonButton } from '../../../../components/buttons';
// import RaisedButton from 'material-ui/RaisedButton';
import { renderAutoCompleteSingleSelect,
  renderTextField,
} from '../../../../components/reduxFields';
import { getPatientPayerServiceCodes } from './actions/soapActions';
import { Scrollbars } from 'react-custom-scrollbars';
const validate = (values) => {
  const errors = {};

  if (!values.CPTID || !Number.isInteger(values.CPTID)) {
    errors.CPTID = 'Please select CPT code.';
  }
  return errors;
};

// props.master_CPT ? props.master_CPT :

class CPTModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      //masterCPT: [],
      isValidServiceCode: true,
      dropdownProcedureCodes: [],
      dropdownProcedureCodeModifiers: [],
      dropdownFilteredModifiers: [],
      attachedModifiers:'',
    };
    this.filter = {
      searchText: '',
    };
    // this.handleSearchCPTcodes = this.handleSearchCPTcodes.bind(this);
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.closeDialog();
  };

  loadCPTs() { // description: this.filter.searchText,
    let searchObj = {
      patientId: this.props.patientId,
      payerPreference: 'primary',
      dateTime: this.props.dateOfService,
      patientInsuranceId: this.props.patientInsuranceId || null,
    };
    this.props.getPatientPayerServiceCodes(searchObj);
  }

  componentWillMount() {
    // this.props.getMasterData();
    this.loadCPTs();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.payerCptCodes && this.props.payerCptCodes !== nextProps.payerCptCodes) {
      let payerData = nextProps.payerCptCodes;
      let payerCptCodes = [];
      let payerCptCodeModifiers = [];
      if (payerData && payerData.ServiceCodes) {
        payerCptCodes = (payerData.ServiceCodes || []).map((cpt, index) => {
          return {
            'id': cpt.serviceCodeId,
            'value': cpt.serviceCode,
            ...cpt,
          };
        });
      }
      if (payerData && payerData.ServiceCodeModifiers) {
        payerCptCodeModifiers = (payerData.ServiceCodeModifiers || []).map((cptModifier, index) => {
          return {
            'id': cptModifier.payerModifierId,
            'value': cptModifier.modifier,
            ...cptModifier,
          };
        });
      }

      //let cptCodes = payerCptCodes.filter((data) => data.isRequiredAuthorization === true);
      this.setState({
        dropdownProcedureCodes: payerCptCodes,
        dropdownProcedureCodeModifiers: payerCptCodeModifiers,
      });
    }

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  handleNewRequest = (input, selectedRecord) => {

    if (input.name === 'CPTID') {
      let cptData = this.state.dropdownProcedureCodes.find((obj) => obj.id === selectedRecord.value);
      if (cptData) {        
        let isValid = cptData.isRequiredAuthorization ? cptData.isValid : true;
        let dropdownFilteredModifiers = (this.state.dropdownProcedureCodeModifiers || []).filter((obj) => {
          return obj.payerServiceCodeId === (cptData && cptData.payerServiceCodeId);
        });
        //console.log('dropdownFilteredModifiers...........',dropdownFilteredModifiers);
        this.setState({ isValidServiceCode: isValid, dropdownFilteredModifiers: dropdownFilteredModifiers });        
      }
    }
    else
    {
        let attachedModifiers = this.state.attachedModifiers;
        if(attachedModifiers === '')
        {
            attachedModifiers = selectedRecord.label; 
        }
        else
        {
          attachedModifiers = attachedModifiers + ', ' +  selectedRecord.label;
        }
        this.setState({ attachedModifiers: attachedModifiers});        
    }
    //console.log('selectedRecord...........',selectedRecord);
    input.onChange(selectedRecord.value);  
  }
  // handleSearchCPTcodes(value, dataSource) {
  //   // console.log(value);
  //   if (value.trim().length >= 3) {
  //     this.filter.searchText = value;
  //     this.loadCPTs();
  //   } else if (value === '') {
  //     this.filter.searchText = '';
  //     this.loadCPTs();
  //   }
  // }
  onAddSubmitHandler = (formProps) => {
    if (this.state.isValidServiceCode) {
      let cptData = this.state.dropdownProcedureCodes.find((obj) => obj.id === formProps.CPTID);
      if (cptData) {
        formProps.AuthProcedureCPTLinkId = cptData.authProcedureCPTLinkId;
        formProps.AuthorizationNumber = cptData.authorizationNumber;
        formProps.attachedModifiers = this.state.attachedModifiers;
      }
      this.props.handleAddCPT(formProps);
      this.handleClose();
    }
  }
  onAddMoreSubmitHandler = (formProps) => {
    if (this.state.isValidServiceCode) {
      let cptData = this.state.dropdownProcedureCodes.find((obj) => obj.id === formProps.CPTID);
      if (cptData) {
        formProps.AuthProcedureCPTLinkId = cptData.authProcedureCPTLinkId;
        formProps.AuthorizationNumber = cptData.authorizationNumber;
        formProps.attachedModifiers = this.state.attachedModifiers;
      }
      this.props.handleAddCPT(formProps);
      this.props.dispatch(reset('Form_SoapCPTModal'));
      this.filter.searchText = '';
      let cptCodes = this.state.dropdownProcedureCodes;
      let indexCpt = this.state.dropdownProcedureCodes.indexOf(cptData);
      cptCodes.splice(indexCpt, 1);
      this.setState({ dropdownProcedureCodes: cptCodes });
      // this.loadCPTs();
    }
  }

  render() {
    const { handleSubmit } = this.props;
    let btns = [
      <CommonButton label="Cancel" className="mr-15 grey_btn" onTouchTap={this.handleClose}/>,
      <CommonButton type="submit" label= "Add" className="mr-15" primary={true} onTouchTap={handleSubmit(this.onAddSubmitHandler)}/>,
      <CommonButton type="submit" primary={true} label= "Add More" onTouchTap={handleSubmit(this.onAddMoreSubmitHandler)}/>,
    ];

    const actions = [ <div className="sm-btn-scroll"><Scrollbars>{btns} </Scrollbars></div>]
    return (
      <div>
        {this.state.open ?
          <Dialog className="custom_modal"
            title={'Add Service Codes'}
            modal={false}
            open={this.state.open}
            actions={actions}
            // onRequestClose={this.handleClose}
            autoScrollBodyContent={true}
          >
            <div className="row">
              <div className="col-sm-12">
                <form className="readmin-form custom_form">
                  <div className="row">
                    <div className="col-sm-12 require mt-40">
                      <Field
                        name="CPTID"
                        label="Search Service Code"
                        options={this.state.dropdownProcedureCodes}
                        handleNewRequest={this.handleNewRequest}
                        // handleUpdateInput={this.handleSearchCPTcodes}
                        customError={!this.state.isValidServiceCode ? 'Selected service code is not authorized.' : undefined}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                    <div className="col-sm-12">
                      <div className="row">
                        <div className="col-sm-3 col-md-3 mt-35">
                          <Field
                            name="Modifier1"
                            label="Modifier 1"
                            handleNewRequest={this.handleNewRequest}
                            options={this.state.dropdownFilteredModifiers}
                            component={renderAutoCompleteSingleSelect}
                          />
                         
                        </div>
                        <div className="col-sm-3 col-md-3 mt-35">
                          <Field
                              name="Modifier2"
                              label="Modifier 2"
                              handleNewRequest={this.handleNewRequest}
                              disabled={this.props.Modifier1 ? false : true}
                              options={this.state.dropdownFilteredModifiers}
                              component={renderAutoCompleteSingleSelect}
                            />
                         
                        </div>
                        <div className="col-sm-3 col-md-3 mt-35">
                          <Field
                            name="Modifier3"
                            label="Modifier 3"
                            handleNewRequest={this.handleNewRequest}
                            disabled={this.props.Modifier2 ? false : true}
                            options={this.state.dropdownFilteredModifiers}
                            component={renderAutoCompleteSingleSelect}
                          />
                        </div>
                        <div className="col-sm-3 col-md-3 mt-35">
                          <Field
                            name="Modifier4"
                            label="Modifier 4"
                            handleNewRequest={this.handleNewRequest}
                            disabled={this.props.Modifier3 ? false : true}
                            options={this.state.dropdownFilteredModifiers}
                            component={renderAutoCompleteSingleSelect}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Dialog> : null}
      </div>
    );
  }
}

const selector = formValueSelector('Form_SoapCPTModal');
const mapStateToProps = (state, ownProps) => ({
  Modifier1: selector(state, 'Modifier1'),
  Modifier2: selector(state, 'Modifier2'),
  Modifier3: selector(state, 'Modifier3'),
  Modifier4: selector(state, 'Modifier4'),
  loading: state.soap.loading,
  payerCptCodes: state.soap.searched_CPTs && state.soap.searched_CPTs.data ? state.soap.searched_CPTs.data : [],
});

CPTModal = reduxForm({
  form: 'Form_SoapCPTModal',
  validate,
  enableReinitialize: true,
})(CPTModal);

export default connect(mapStateToProps, { getPatientPayerServiceCodes })(CPTModal);



// WEBPACK FOOTER //
// ./src/modules/scheduling/components/SessionNotes_EBS/soap_CPTModal.js